<template>
  <div v-show="p_active" class="c2_2_1">
    <div class="divSearch">

      <div class="divBox250">
        <p>角色：</p>
        <select v-model="searchRow.fidrole" class="picker" aria-placeholder="角色">
          <option v-for="mm in roles" v-if="mm.fid>0" :key="mm.fid" :value="mm.fid">{{ mm.fname }}</option>
        </select>
      </div>
      <div class="divBox150">
        <button @click="getDs">查询</button>
        <button :disabled="bbSave" @click="save"> 保存</button>
        <i v-show="bbSave" class="el-icon-loading" style="font-size: 21px;padding: 2px;color:blue;"/>
        <p class="pError">{{ errMsg }}</p>
      </div>
    </div><!--查询-->
    <div :style="[{'width':(mainWidth-195)+'px'},{'height':(mainHeight-180)+'px'}]" class="divList">
      <table class="tbList">
        <thead>
          <tr class="tbListHead"><!-- class="editTbHead"-->
            <th/>
            <th>模块</th>
            <th>菜单</th>
            <th><a @click="pickAll('factread')">查看</a></th>
            <th><a @click="pickAll('factedit')">编辑</a></th>
            <th><a @click="pickAll('factdelt')">删除</a></th>
            <th><a @click="pickAll('factaudit')">审核</a></th>
            <th><a @click="pickAll('factunchk')">反审核</a></th>
            <th><a @click="pickAll('factset')">分配</a></th>
            <th><a @click="pickAll('facttrans')">出库</a></th>
            <th><a @click="pickAll('factcancel')">取消出库</a></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row,idx) in tbData"
            :key="idx"
            :class="idx===idTr || idx===idTrCk?'trOver':''"
            @mouseout="trOut"
            @mouseover="trOver(idx)"
            @mousedown="trClick(idx)">
            <td class="tdIdx">{{ idx+1 }}</td>
            <td>{{ row.fname }}</td>
            <td>{{ row.fnamemenu }}</td>
            <td><input v-model="row.factread" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="row.fidparent===2" v-model="row.factedit" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="row.fidparent===2" v-model="row.factdelt" class="iptChkBox" type="checkbox"></td>

            <td><input v-if="row.fidparent===2" v-model="row.factaudit" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="row.fidparent===2" v-model="row.factunchk" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="comm.numIn(row.fidm,[7,8,12,13])" v-model="row.factset" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="comm.numIn(row.fidm,[7,8,12,13])" v-model="row.facttrans" class="iptChkBox" type="checkbox"></td>
            <td><input v-if="comm.numIn(row.fidm,[7,8,12,13])" v-model="row.factcancel" class="iptChkBox" type="checkbox"></td>
          </tr>
        </tbody>
      </table>
    </div><!--列表-->
  </div>
</template>
<script type="text/javascript">
import CEdit from './02_edit.vue'
import CPrint from './04_view.vue'
import MsgBox from '../c2_info/06_msgBox.vue'
import './../../../static/c_div.css'
import './../../../static/c_table.css'
export default{
  name: 'CList',
  components: {
    CPrint,
    MsgBox,
    CEdit
  },
  props: {
    p_id: {
      type: Number,
      default: 0
    }, /**/
    p_title: {
      type: String,
      default: '欢迎使用'
    },
    p_iAct: {
      type: Number,
      default: 21
    },
    p_active: {
      type: Boolean,
      default: false
    },
    p_url: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      bbSave: false,
      errMsg: '',
      idTr: 0,
      idTrCk: 0,
      colm: {},
      tbProp: {},
      searchRow: {},
      mainWidth: 1000,
      mainHeight: 500,
      tbData: [],
      roles: []
    }
  },
  watch: {
  },
  mounted() {
    const my = this
    this.mainWidth = this.$getWH().orgW
    this.mainHeight = this.$getWH().orgH
    window.onresize = () => {
      return (() => {
        my.mainWidth = document.body.clientWidth
        my.mainHeight = document.body.clientHeight
      })()
    }
  },
  created: function() {
    this.getRole()
  },
  methods: {
    prt(a, b) {
      console.log(`c7_perview.${a}`, b)
    },
    pickAll(act) {
      this.tbData.forEach(row => {
        row[act] = (!row[act])
      })
    },
    getRole() {
      this.searchRow = {
        iAct: 34,
        fidmenu: 4,
        fstat: 0
      }
      this.$jPost('/b/info', this.searchRow, rs => { // + '/find'
        this.roles = rs.data.data
        this.prt('getDs.roles', this.roles)
      })
    },
    getDs() {
      // this.bbEdit = false//TODO:1.W保存后刷新、隐藏编辑窗
      // this.searchRow['fnamerole'] = 142
      this.bbSave = true
      if (!this.searchRow || !this.searchRow.fidrole || this.searchRow.fidrole === '') {
        this.errMsg = '请选择角色'
        setTimeout(() => {
          this.errMsg = ''
        }, 2000)
        return
      }
      this.searchRow['iAct'] = this.p_iAct
      this.$jPost(this.p_url, this.searchRow, rs => { // + '/find'
        this.tbData = rs.data.data
        this.prt('getDs.tbData', this.tbData)
        this.bbSave = false
      })
    },
    trOver(idTr) {
      this.idTr = idTr
    },
    trOut() {
      this.idTr = -1
    },
    trClick(idTr) {
      if (idTr === this.idTrCk) {
        this.idTrCk = -1
      } else {
        this.idTrCk = idTr
      }
    },
    save() {
      this.bbSave = true
      this.prt('save.tbData', this.tbData)
      /* const param = {
        fidrole: this.searchRow.fidrole,
        entrys: this.tbData
      }*/
      this.tbData.forEach(row => {
        row.fidrole = this.searchRow.fidrole
      })
      this.$jPost('/b/savePerview', this.tbData, rs => { // + '/find'
        this.prt('getDs.save', rs)
        this.bbSave = false
        alert('保存成功')
      })
    }
  }
}
</script>
<style scoped>
.pError{
  color:red;
  width: auto;
  text-wrap: nowrap;
}
.picker{
  width: 250px;
  border: 1px solid blue;
  padding: 3px;
  border-radius: 2px;
}
.iptChkBox{
  width: 17px;
}
</style>



// WEBPACK FOOTER //
// src/comps/c2_info/07_perview.vue